<template>
  <nav>
    <div class="flex justify-between">
      <div class="flex items-center">
        <img src="../../assets/img/corbusier.png" class="h-8 mr-3" alt="">
        <div class="flex-col md:flex">
          <h1>
            <strong>建築之神我要告解</strong>
          </h1>
          <p class="text-sm">建築職涯反思匿名留言板</p>
        </div>        
      </div>
      <div v-if="isLogin" class="login flex items-center">
        <Avatar :src="user.photoURL" />
        <button class="text-black hover:text-gray-600" @click="signOut">
          登出
        </button>
      </div>
      <button v-else class="bg-yellow-300 text-gray-800  hover:bg-gray-400 hover:text-white duration-300 "
        @click="signIn">
        登入留言
      </button>      
    </div>
    <div class="h-5 w-full flex justify-center">
      <p class="text-sm">1000 位建築人內觀達成: <span class="bg-yellow-100">{{messagesNumbers}}／1000</span></p>
    </div>
  </nav>
  <!-- <div class="w-full overflow-y-auto bg-yellow-100 py-4 text-white">
      <p>嗨 ,建築家人,歡迎你千里迢迢來到這隱蔽的地方，這裡要蒐集1000位建築人的匿名自我內心反省，
      </p>
    </div> -->
</template>

<script>
import Avatar from './Avatar.vue'
import { useAuth, useChat } from '@/firebase'

export default {
  components: { Avatar },
  setup() {
    const { user, isLogin, signOut, signIn } = useAuth()
    const { messagesNumbers} = useChat()
    return { user, isLogin, signOut, signIn, messagesNumbers }
  }
}
</script>
